<div class="order-history-container pt-5">
    <div class="table-controls-container" *ngIf="(inventoryDestructions$ |async)?.length; let count">
        <div class="header-container flex flex-row justify-between items-center">
            <div class="flex flex-col">
                <div class="text-title-2">Wastes / Destructions</div>
                <div class="sub-header">
                There {{count !== 1 ? 'are' : 'is'}}
                <div class="bold">{{count}}</div>
                waste{{count !== 1 ? 's' : ''}} / destruction{{count !== 1 ? 's' : ''}}
                </div>
            </div>
            <app-button 
                text="Waste / Destroy Inventory"
                [minWidth]="205"
                (clicked)="openDialog()">
            </app-button>
        </div>

        <div class="table-controls search-control">
            <app-search-input
                [color]="SearchInputColorEnum.Green"
                [hideDropdown]="true"
                placeholder="Search by name or location"
                [loading]="loading$ | async"
                (searchValueChanged)="searchValueChanged($event)"
            ></app-search-input>
        </div>
    </div>

    <app-button *ngIf="!(inventoryDestructions$ |async)?.length && !(loading$ | async)"
        class="!flex justify-end pr-8"
        text="Waste / Destroy Inventory"
        [minWidth]="205"
        (clicked)="openDialog()">
    </app-button>

    <app-generic-table *ngIf="(inventoryDestructions$ |async)?.length"
        [data]="filtered$ | async" 
        [columns]="columns"
        (goToDetail)="openDetail($event)"
    ></app-generic-table>
</div>

<app-destroy-inventory-dialog *ngIf="addDestructionDialog"
    [autocompleteData]="placesOfDestruction$ | async"
    (itemAdded)="addPlaceOfDestruction($event)"
    (submit)="destructionSubmitted($event)"
    (cancel)="addDestructionDialog = false"
></app-destroy-inventory-dialog>

<app-empty-table *ngIf="!(loading$ | async) && !(inventoryDestructions$ | async)?.length"
  [labelValue]="'You do not have any orders yet'"
></app-empty-table>